import React, { useRef } from "react";
import { Form } from "react-bootstrap";
import { FiUploadCloud } from "react-icons/fi";

export const UploadImage = ({
    label = "Upload Image",
    name = "image",
    value = "",
    onChange,
    error = "",
    accept = "image/*",
    disabled = false,
    className,
    icon,
}) => {

    const inputRef = useRef();

    const handleClick = () => {
        if (!disabled) { inputRef.current.click(); }
    };

    const handleFileChange = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        if (onChange) {
            onChange({ target: { name, value: file } });
        }
    };

    return (
        <Form.Group  className="m-auto">

            {label && ( <Form.Label className="fw-semibold mb-2"> {label} </Form.Label> )}

            {/* UPLOAD BOX */}
            <div
                onClick={handleClick}
                className={`upload-img-box ${value ? "p-0" :"p-2"}`}
            >

                {/* PREVIEW */}
                { value ? ( 
                     <img
                            src={
                                typeof value === "string"
                                    ? value
                                    : URL.createObjectURL(value)
                            }
                            alt="preview"
                            className="object-fit-fill rounded"
                            width={125}
                            height={125}
                        />

                    ) : (

                        <>
                            {icon ? icon : <FiUploadCloud
                                size={40}
                                className="mb-2 text-primary"
                            />}

                            <p className="mb-0 small">
                                Click to upload image
                            </p>
                        </>
                    )
                }

            </div>

            {/* HIDDEN INPUT */}
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                hidden
                disabled={disabled}
                onChange={handleFileChange}
            />

            {/* ERROR */}
            {  error && ( <small className="text-danger">  {error}   </small> ) }

        </Form.Group>
    );
};